import { useEffect } from "react";

const GTM_ID = "GTM-5PSDKDPQ";

export default function GtmLoader() {
  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (consent !== "accepted") return;
    if (document.getElementById("gtm-script")) return;

    const s = document.createElement("script");
    s.id = "gtm-script";
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
    document.head.appendChild(s);

    const noscript = document.createElement("noscript");
    noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_ID}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    document.body.appendChild(noscript);
  }, []);

  return null;
}
